const hasSpotTickerConsumer = ws => ws?.eventsKeys?.some(key => ws.isTopicMatched(key, WS_KEYS.ticker)) // 前端有没有本地消费者
const getPendingSpotTickerCommandKey = cmd => `${cmd}:${WS_KEYS.ticker}`
const hasPendingSpotTickerCommand = (ws, cmd) => Boolean(ws?.sends?.[getPendingSpotTickerCommandKey(cmd)]) // 待发送队列
const hasActiveSpotTickerSubscription = ws => Boolean(ws?.subPayloads?.[WS_KEYS.ticker])
const clearPendingSpotTickerCommand = (ws, cmd) => {
  if (!ws?.sends) {
    return
  }

  delete ws.sends[getPendingSpotTickerCommandKey(cmd)]
}

export const onSpotTicker = (eventKey, cb) => {
  const ws = Socket.autoConnect()
  const hadConsumer = hasSpotTickerConsumer(ws)

  ws.on(eventKey, cb)

  if (hadConsumer) {
    return
  }

  clearPendingSpotTickerCommand(ws, 'unsub')
  if (hasActiveSpotTickerSubscription(ws) || hasPendingSpotTickerCommand(ws, 'sub')) {
    return
  }

  ws.send({
    id: randomString(),
    cmd: 'sub',
    topic: WS_KEYS.ticker,
    data: {}
  })
}

export const offSpotTicker = (eventKey) => {
  const ws = Socket.instance

  if (!ws?.hasEvent(eventKey)) {
    return
  }

  ws.off(eventKey)

  if (hasSpotTickerConsumer(ws)) {
    return
  }

  const hadPendingSub = hasPendingSpotTickerCommand(ws, 'sub')
  clearPendingSpotTickerCommand(ws, 'sub')
  if (hadPendingSub && !hasActiveSpotTickerSubscription(ws)) {
    return
  }

  if (!hasActiveSpotTickerSubscription(ws)) {
    return
  }

  ws.send({
    cmd: 'unsub',
    topic: WS_KEYS.ticker,
    data: {}
  })
}

export const offSpotTickerByPattern = (pattern) => {
  const ws = Socket.instance

  if (!ws) {
    return
  }

  ws.eventsKeys
    .filter(eventKey => pattern.test(eventKey))
    .forEach(eventKey => offSpotTicker(eventKey))
}
